import { Outlet } from 'react-router-dom';

// project-imports
import Drawer from './Drawer';
import Header from './Header';
import useConfig from 'hooks/useConfig';
import NavigationScroll from 'components/NavigationScroll';
import FloatingActionMenu from '../../components/common/FloatingMenu/FloatingActionMenu';
import SubscriptionWall from 'components/SubscriptionWall/SubscriptionWall';
import useAuth from 'auth/useAuth';

export default function MainLayout() {
  const { themeDirection, customColor, mode, container } = useConfig();
  const { user, meLoading } = useAuth();

  const isInactive = !meLoading && user?.user?.user_type === 'merchant_admin' && user?.subscription?.status !== 'active';

  return (
    <div data-pc-preset={customColor} data-pc-direction={themeDirection} data-pc-theme={mode}>
      <Drawer />
      <Header />
      <div className="pc-container">
        <div className={`pc-content ${container && 'container'} `}>
          <NavigationScroll>
            {!isInactive && <Outlet />}
          </NavigationScroll>
        </div>
        {!isInactive && <FloatingActionMenu />}
      </div>
      <SubscriptionWall />
    </div>
  );
}
